import { render, staticRenderFns } from "./TransferFundsAddNewPayee.vue?vue&type=template&id=476366f2"
import script from "./TransferFundsAddNewPayee.vue?vue&type=script&lang=js"
export * from "./TransferFundsAddNewPayee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports